
import Vue from "vue";
import { SyncManager, SyncManagers } from "../Sync";
import { Ledgers } from "../Ledger";
import { s } from "../L10n";

export function makeJoinLink(sync: SyncManager): string {
  return btoa(
    JSON.stringify({
      relayAddress: sync.relayAddress,
      id: sync.id,
      key: sync.key,
    })
  );
}

export default Vue.extend({
  data() {
    let token: string = "";
    if (window.location.hash.startsWith("#/join/")) {
      token = window.location.hash.substring(7);
    }
    return { token };
  },
  mounted() {
    if (this.token) {
      this.onClick();
    }
  },
  methods: {
    async onClick() {
      if (!this.parsed) return;
      const [id, key] = this.parsed;
      const ledger = Ledgers.add(id, key);
      await SyncManagers.register(ledger);
      this.$router.push({ name: "ledger", params: { id: id } });
    },
    back() {
      this.$router.push({ name: "list" });
    },
    s(str: string): string {
      return s(str);
    }
  },
  computed: {
    parsed(): [string, string] | undefined {
      if (!this.token) return;
      if (this.token.length == 0) return;
      try {
        const obj = JSON.parse(atob(this.token));
        const id = obj.id;
        const key = obj.key;
        // const relayAddress = obj.relayAddress;
        if (id.length != 36 || key.length == 0) {
          // FIXME: better checks
          return;
        }
        return [id, key];
      } catch {}
    },
    state(): boolean | null {
      if (!this.token) return null;
      return !!this.parsed;
    },
  },
});
